import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react";
import { FC } from "react";

const CustomButton: FC<
  {
    onClick?: VoidFunction;
    type?: "button" | "submit" | "reset" | undefined;
    isDisabled?: boolean;
  } & ButtonProps
> = ({ type, isDisabled, onClick, ...props }) => {
  const bg = useColorModeValue("primary.500", "primary.600");

  return (
    <Button
      bgColor={bg}
      fontSize="14px"
      width="100%"
      w="full"
      h="48px"
      type={type}
      fontWeight="normal"
      borderRadius="4px"
      isDisabled={Boolean(isDisabled || props.isLoading)}
      onClick={onClick}
      color="white"
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default CustomButton;
